// Utilidades para los turnos. Formatos de fechas, horas. Termino y comienzo

export const getRemainingTime = (shift) => {
  if (!shift || !shift.start || !shift.end) return "";

  const now = new Date();

  // Antes de que empiece el turno
  if (now < shift.start) {
    const diffMs = shift.start - now;

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `Empieza en ${hours}h ${minutes}m`;
  }

  // Durante el turno
  if (now >= shift.start && now <= shift.end) {
    const diffMs = shift.end - now;

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `Faltan ${hours}h ${minutes}m para terminar turno`;
  }

  return "Turno finalizado";
};


export const getShiftDateTime = (shift, shiftTemplates) => {
  const template = shiftTemplates.find(t => t.id === shift.shiftTemplateId);
  if (!template) return null;

  const start = new Date(`${shift.shiftDate}T${template.startTime}`);
  let end = new Date(`${shift.shiftDate}T${template.endTime}`);

  // Si la hora de fin es anterior o igual a la de inicio, significa que es al día siguiente
  if (end <= start) {
    end.setDate(end.getDate() + 1);
  }

  return { start, end };
};

export const getShiftStart = (shift, shiftTemplates) => {
  return getShiftDateTime(shift, shiftTemplates)?.start || null;
};

export const getShiftEnd = (shift, shiftTemplates) => {
  return getShiftDateTime(shift, shiftTemplates)?.end || null;
};

export const getActiveShift = (shifts, shiftTemplates) => {
  const now = new Date();

  const shiftsWithTime = shifts
    .map(s => {
      const times = getShiftDateTime(s, shiftTemplates);
      if (!times) return null;
      return { ...s, ...times };
    })
    .filter(Boolean);

  const past = shiftsWithTime
    .filter(s => s.end < now)
    .sort((a, b) => b.start - a.start);

  const future = shiftsWithTime
    .filter(s => s.start >= now)
    .sort((a, b) => a.start - b.start);

  const current = shiftsWithTime.find(
    s => s.start <= now && s.end >= now
  );

  return current || future[0] || past[0] || null;
};

export const getShiftAttendance = (shift, attendances) => {
  const safeAttendances = Array.isArray(attendances) ? attendances : [];
  return safeAttendances.find(a => a.scheduledShiftId === shift?.id) ?? null;
}